module.exports = __webpack_public_path__ + "img/forgot-password-v2.fb2b930b.svg";